import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { EmojiPickerDirective } from "./emoji-picker.directive";

@NgModule({
  imports: [CommonModule],
  declarations: [EmojiPickerDirective],
  exports: [EmojiPickerDirective]
})
export class EmojiModule {}
